export const FEATURES = {
  MOD_CRM: "MOD_CRM",
  MOD_FOOD: "MOD_FOOD",
  MOD_SERVICOS: "MOD_SERVICOS",
  MOD_TRANSPORTE: "MOD_TRANSPORTE",
  MOD_PRODUCAO: "MOD_PRODUCAO",
  MOD_OTICAS: "MOD_OTICAS",
  MOD_AGRO: "MOD_AGRO",
  MOD_PET: "MOD_PET",
  MOD_SAUDE: "MOD_SAUDE",
  MOD_BEAUTY: "MOD_BEAUTY",

  PLG_FISCAL_PRO: "PLG_FISCAL_PRO",
  PLG_BALANCAS: "PLG_BALANCAS",
  PLG_ECOMMERCE: "PLG_ECOMMERCE",
  PLG_PDV_OFFLINE: "PLG_PDV_OFFLINE",
  PLG_DELIVERY: "PLG_DELIVERY",
  PLG_TEF: "PLG_TEF",
  PLG_ETIQUETAS: "PLG_ETIQUETAS",
  PLG_CATALOGO: "PLG_CATALOGO",
  PLG_AGENDA: "PLG_AGENDA",
  PLG_MULTIEMPRESA: "PLG_MULTIEMPRESA",
  PLG_IA: "PLG_IA",
  PLG_CONDICIONAL: "PLG_CONDICIONAL",
  PLG_WHATSAPP: "PLG_WHATSAPP",
  PLG_BI: "PLG_BI",
};
